import * as Yup from 'yup';

export const stipTypeEditorValidationSchema = Yup.object().shape({
  name: Yup.string().nullable().required('Name is required'),
  relatedToEntity: Yup.string().nullable().required('Update to type is required'),
});
